import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { routineInsUpdSlice, selectRoutineInsUpd } from "../../../redux/routine/routineInsUpdSlice";
import { useAppDispatch } from "../../../app/hooks";
import AvatarUploadDragAndDrop from "../../../features/base/image/AvatarUploadDragAndDrop";

export function RoutineInsUpdData() {
    const routineInsUpd = useSelector(selectRoutineInsUpd);
    const dispatch = useAppDispatch();

    const changedName = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const routine = {
            ...routineInsUpd.routine
        };
        routine.name = event.target.value;
        dispatch(routineInsUpdSlice.actions.set(routine));
    };

    const handleAvatarChange = (img: string) => {
        const routine = {
            ...routineInsUpd.routine,
            url: img
        };
        dispatch(routineInsUpdSlice.actions.set(routine));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados da sala de aula
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                    fullWidth autoComplete="nome" variant="standard"
                    value={routineInsUpd.routine.name}
                    onChange={changedName} />
            </Grid>
            <Grid size={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Avatar
                </Typography>
                <AvatarUploadDragAndDrop
                    value={routineInsUpd.routine.url || ""}
                    onChange={handleAvatarChange}
                    alt={routineInsUpd.routine.name}
                />
            </Grid>
        </Grid>
        </>;
}